import { render, staticRenderFns } from "./title-text-content.vue?vue&type=template&id=366fb17e&scoped=true"
import script from "./title-text-content.vue?vue&type=script&lang=js"
export * from "./title-text-content.vue?vue&type=script&lang=js"
import style0 from "./title-text-content.vue?vue&type=style&index=0&id=366fb17e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366fb17e",
  null
  
)

export default component.exports